var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"item",class:{'is-active': _vm.active},on:{"click":function($event){return _vm.$emit('click')}}},[_c('div',{staticClass:"item-icon"},[_c('i',{staticClass:"fa",class:{['fa-' + _vm.icon]: true}})]),_c('div',{staticClass:"item-text"},[_vm._v(_vm._s(_vm.text))])])
}
var staticRenderFns = []

export { render, staticRenderFns }